import { fetchLoginSendAuthCode, fetchLoginWhoAmI } from "@crowdcoursing/api/openapi";
import { type Location } from "react-router-dom";

import { type Dispatch } from "../hooks/useTypedRedux";
import { Route } from "../services/router/Route";
import { browserRouter } from "../services/router/router";
import { actions as authActions } from "../state/auth";
import { actions as userActions } from "../state/userSlice";

/** @deprecated We are phasing out `redux` */
export interface LoginRedirect {
  from: Location;
}

/** @deprecated We are phasing out `redux` */
interface LoginProps {
  email?: string;
  phone?: string;
  redirectState?: LoginRedirect;
}

/** @deprecated We are phasing out `redux` */
const login =
  ({ email, phone, redirectState }: LoginProps) =>
  async (dispatch: Dispatch) => {
    dispatch(authActions.loginRequested());

    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const result = await fetchLoginSendAuthCode({
        body: { email, phoneNumber: phone, timezone },
      });

      if (result === "") {
        // @ts-expect-error - email or phone is required and validated by form and backend
        dispatch(authActions.loginSuccess(email || phone));
        browserRouter.navigate(Route.verify(), { state: redirectState });
      }
    } catch {
      dispatch(authActions.loginFailed());
    }
  };

/**
 * login via a token, loading any secondary data
 *
 * This method is used by e2e tests, should contain any additional fetches
 * to load state
 *
 * @deprecated We are phasing out `redux`
 */
export const loginWithToken = async (token: string, dispatch: Dispatch): Promise<void> => {
  dispatch(authActions.verifySuccess(token));
  // use the token to get more data
  const user = await fetchLoginWhoAmI({});
  dispatch(userActions.whoamiSuccess({ user }));
};

/** @deprecated We are phasing out `redux` */
export const LoginActions = { login, logout: userActions.logout };
